import {getFromMeta} from './csrfToken';

export default (url, options = {}) => {
  const defaultOptions = {
    credentials: 'same-origin',
  };
  const defaultHeaders = {
    'X-CSRF-Token': getFromMeta(),
  };

  const mergedHeaders = Object.assign({}, defaultHeaders, (options.headers || {}));
  const mergedOptions = Object.assign({}, defaultOptions, options, {headers: mergedHeaders});

  return fetch(url, mergedOptions);
};



// WEBPACK FOOTER //
// ./app/javascript/utils/fetch.js